<template>
  <div class="transaction-list">
    <div class="list-header">
      <div class="header-item">哈希值</div>
      <div class="header-item">交易对</div>
      <div class="header-item">交易金额</div>
      <div class="header-item" style="text-align: right">交易时间</div>
    </div>
    <div class="list-body">
      <div class="list-item" v-for="(item, index) in transactionList" :key="index">
<!--        多余省略 当前页面 用grid 布局 30% 15% 25% 30%-->
        <div class="item-hash">
          <a :href="'https://bscscan.com/tx/' + item.txHash" target="_blank">{{ item.txHash }}</a>
        </div>
        <div class="item-pair">
          <div class="pair-icons">
            <img class="coin-icon" :src="item.fromTokenImageUrl" alt="">
            <img class="coin-icon second" :src="item.toTokenImageUrl" alt="">
          </div>
        </div>
        <div class="item-amount">
          +{{ $formatWithCommas(item.volume) }}
        </div>
        <div class="item-time">{{ $getTimeNew(item.date,'mm-dd HH:MM') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransactionList',
  props: {
    // 交易列表数据
    transactions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 示例数据，实际应该通过props传入
      transactionList: this.transactions
    };
  },
  methods: {
    // 格式化哈希值，只显示前10位和后6位
    formatHash(hash) {
      if (!hash) return '';
      return hash.substring(0, 10) + '...' + hash.substring(hash.length - 6);
    }
  }
};
</script>

<style lang="scss" scoped>
.transaction-list {
  border-radius: 12px;
  overflow: hidden;
  background-color: #fff;
  border: 0.5px solid $border;
  padding: 0 15px;

  .list-header {
    display: grid;
    grid-template-columns: 30% 15% 25% 30%;
    height: 50px;
    line-height: 50px;
    font-size: 12px;
    color: $color1;

    .header-item {
      &:first-child {
        text-align: left;
      }
      &:nth-child(2), &:nth-child(3) {
        text-align: center;
      }
      &:last-child {
        text-align: center;
      }
    }
  }

  .list-body {
    .list-item {
      display: grid;
      grid-template-columns: 30% 15% 25% 30%;
      align-items: center;
      height: 50px;
      line-height: 50px;
      border-top: 0.5px solid $border;
      font-size: 12px;

      a {
        color: #0052EB;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}

.item-hash {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #0052EB;

  a {
    color: #0052EB;
    font-size: 12px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.item-pair {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pair-icons {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.coin-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;

  &.second {
    margin-left: -5px;
  }
}

.item-amount {
  text-align: center;
  color: $color;
  font-size: 14px;
  font-weight: 500;
}

.item-time {
  text-align: right;
  color: $color1;
}
</style>